(function (angular, app) {
    'use strict';

    app.filter('replaceAll', [
        function() {
            return function(target, from, to) {
                return target.replace(new RegExp(from, 'g'), to);
            };
        }]);
})(angular, app);